import { render, staticRenderFns } from "./Benchmarking.vue?vue&type=template&id=00cab632&scoped=true"
import script from "./Benchmarking.vue?vue&type=script&lang=ts"
export * from "./Benchmarking.vue?vue&type=script&lang=ts"
import style0 from "./Benchmarking.vue?vue&type=style&index=0&id=00cab632&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cab632",
  null
  
)

export default component.exports